import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static values = { url: String }

  connect() {
    reactor(this)
  }

  morph() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return
    if (frame.hasAttribute("busy")) return
    frame.src = null
    frame.src = this.urlValue
  }
}
